
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import { PessoaMixin } from "@/modules/Application";
import ContaPagarData, { ContaPagarDataRequired } from "./ContaPagarData";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import VueSelect from "vue-select";
import loadsh from "loadsh";
import "vue-select/dist/vue-select.css";
import { mapGetters } from "vuex";
import TableApp from "@/components/Table/Table3.vue"
import CentroCustoSelect from "@/components/CentroCustoSelect/CentroCustoSelect.vue";

export default {
  name: "app-conta-pagar-form",
  props: {
    url: {
      type: String,
    },
    conta: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    Money,
    VueSelect,
    TableApp,
    CentroCustoSelect,
  },
  mixins: [validationMixin, SistemaMixin, PessoaMixin],
  watch: {
    conta(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
        this.form.valor = this.numberToReal(newValue.valor, 2);
        this.form.valor_total = this.numberToReal(newValue.valor_total, 2);
        this.form.juros = this.numberToReal(newValue.juros, 2);
        this.form.multa = this.numberToReal(newValue.multa, 2);
        this.form.desconto = this.numberToReal(newValue.desconto, 2);
      }
    },
  },
  data() {
    return {
      tabIndex: 0,
      configMoney: settingMoney,
      form: {},
      plano_contas: [],
      fornecedor: null,
      plano: null,
      meioPagamento: null,
      fornecedores: [],
      meiosDePagamento: [],
      meiosDePagamentoFetched: [],
      bancos: [
        {
          id_banco: 99999,
          nome: "Movimento Caixa",
        },
      ],
      vencimentoSelected: null,
      pagamentoEditado: 0,
      selectedPagamento: null,
      indexVencimento: null,
      fields: [
        {
          label: "",
          field: "id",
          slot: true,
          width: "10%",
          sortable: false
        },
        {
          label: "Valor R$",
          field: "valor",
          slot: true,
          width: "45%",
          sortable: false
        },
        {
          label: "Vencimento",
          field: "vencimento",
          slot: true,
          sortable: false,
          width: "45%"
        },
      ],
    };
  },
  validations: {
    form: ContaPagarDataRequired,
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  computed: {
    ...mapGetters(["itsblocked"]),
    valorPagamento() {
      if(!this.form?.parcelas) return;
      if (this.form.parcelas.length === 0) return 0
      else return this.form.parcelas[0].valor
    },
    isNotEdit() {
      return JSON.stringify(this.$route.params) === '{}'
    },
    valor_total() {
      return this.form.valor + this.form.juros + this.form.multa - this.form.desconto;
    },
  },
  methods: {
    setRepetir() {
      this.form.repetir = this.form.repetir ? false : true;
    },
    changePagamento(pagamentoIndex) {
      this.selectedPagamento = pagamentoIndex
    },
    changePagamentoEdited(valor) {
      this.pagamentoEditado = valor;
    },
    salvarPagamento() {
      this.form.parcelas[this.selectedPagamento].valor = this.pagamentoEditado;
      this.$bvModal.hide('modal-pagamento')
    },
    selectVencimento(index) {
      this.indexVencimento = index
    },
    salvarVencimento() {
      this.form.parcelas[this.indexVencimento].data_vencimento = this.vencimentoSelected;
      this.$bvModal.hide('modal-calendar')
    },
    gerarParcelas() {
      if(this.form.valor === 0) {
        this.$toast.error('Insira um valor para gerar parcelas!')
        return;
      };
      this.form.parcelas = this.defineParcelas(this.form.vezes, this.form.valor, this.form.data_vencimento);
    },
    setAtivo() {
      this.form.pago = this.form.pago ? false : true;
    },
    setCliente(fornecedor) {
      this.fornecedor = fornecedor;
    },
    setPlano(plano) {
      this.plano = plano;
    },
    onSearchPlano(search, loading) {
      if (search.length) {
        loading(true);
        this.searchPlano(loading, search, this);
      }
    },
    searchPlano: loadsh.debounce(async (loading, search, vm) => {
      vm.plano_contas = await vm.getPlanoContasContaPagar(search);
      loading(false);
    }, 450),
    onSearchMeioPagamento(search) {
      this.meiosDePagamento = this.meiosPagamentoFetched.filter(pagamento => pagamento.descricao.toLowerCase().includes(search.toLowerCase()))
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: loadsh.debounce(async (loading, search, vm) => {
      vm.fornecedores = await vm.getFornecedorNome(search);
      loading(false);
    }, 350),
    async getDataInit() {
      this.form = new ContaPagarData({});
      this.plano_contas = await this.getPlanoContasContaPagar();

      const bancos = await this.getBancosByEmpresa();

      const response = await this.$http.post('/financeiro/meios-pagamento');
      this.meiosDePagamento = response.data;
      this.meiosPagamentoFetched = this.meiosDePagamento;

      this.bancos.push(...bancos);

      if (this.conta.id) {
        this.form = this.conta;
        this.meioPagamento = this.conta.meio_pagamento; 
        this.setCliente(this.conta.pessoa);
        this.setPlano(this.conta.plano_contas);
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      this.addLoadingToButton('submit_conta_novo')
      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        this.form.pessoa = this.fornecedor;
        this.form.id_plano_contas = this.plano?.id ?? null;
        this.form.id_meio_pagamento = this.meioPagamento?.id ?? null;

        if (this.valor_total) {
          this.form.valor_total = this.valor_total;
        }

        await this.$http.post(this.url, this.form);

        this.$router.push({ name: "contasPagarLista" });
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton('submit_conta_novo')

    },
  },
};
